'use strict';

var _ = require('lodash');
var StepMarketShareController = function StepMarketShareController($scope, $rootScope, validationService) {
  $scope.stepTitle = 'Market Share';
  $scope.isSummaryVisible = false;
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle) {
      $scope.isSummaryVisible = false;
    }
  };
  $scope.validate = function () {
    var valid = true;
    _.forEach($scope.scheduleChange.significantManagedEntities, function (entity) {
      _.forEach(entity.significantPos, function (pos) {
        _.forEach(pos.marketShare.data, function (data) {
          if (data.share === undefined) {
            valid = false;
          }
        });
      });
    });
    if (!valid && $scope.focusErrorMsg) {
      $scope.focusErrorMsg();
    }
    $scope.isSummaryVisible = !valid;
    return valid;
  };
  $scope.resetForm = function () {
    $scope.isSummaryVisible = false;
  };
  validationService.registerValidator('StepMarketShare', $scope.validate);
};
StepMarketShareController.$inject = ['$scope', '$rootScope', 'ValidationService'];
module.exports = StepMarketShareController;